import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { Button, Col, Dropdown, Input, Row } from "antd";
import {
  EllipsisOutlined,
  EditFilled,
  PlusOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { debounce } from "lodash";
import CommonTable from "../../../common/CommonTable";
import EditTeam from "./EditTeam";
import DeleteTeam from "./DeleteTeam";
import { useTeamManagement } from "../hooks/useTeamManagement";
import deleteIcon from "../../../assets/images/webToLead/delete.svg";
import { getManagerNamesFromTeam } from "../../../utils/teamAccess";

const TeamListing = () => {
  const [team, setTeam] = useState();
  const [isDelete, setDelete] = useState();
  const [isAdd, setAdd] = useState(false);
  const {
    teams,
    handleDelete,
    loading: isLoading,
    onFilterChange,
  } = useTeamManagement();
  const [searchParams] = useSearchParams();
  const page = searchParams.get("page");
  const loading = useSelector((state) => state.teamManagementReducer.loading);

  const columns = [
    {
      title: "Name",
      dataIndex: "teamName",
      key: "teamName",
      sorter: true,
    },
    {
      title: "Location",
      dataIndex: "location",
      key: "location",
      sorter: true,
    },
    {
      title: "Manager",
      dataIndex: "managerName",
      key: "managerName",
      sorter: true,
      render: (_, row) => getManagerNamesFromTeam(row).join(", "),
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Actions",
      dataIndex: "id",
      render: (record, row) => {
        const items = [
          {
            key: "1",
            label: (
              <Row
                gutter={row?.active ? 12 : 24}
                className="heading14px"
                style={{ color: "#29292B" }}
                onClick={() => setTeam(row)}
              >
                <Col span={6}>
                  <EditFilled />
                </Col>
                <Col span={17}>Edit</Col>
              </Row>
            ),
          },
          {
            key: "2",
            label: (
              <Row
                gutter={row?.active ? 12 : 24}
                style={{ color: "#29292B" }}
                onClick={() => setDelete(row)}
              >
                <Col span={6} className="!tw-p-0">
                  <img
                    src={deleteIcon}
                    alt=""
                    width={20}
                    height={15}
                    className="cursor-pointer tw-ml-3"
                  />
                </Col>

                <Col span={18} className="heading14px">
                  Delete
                </Col>
              </Row>
            ),
          },
        ].filter(Boolean);

        return (
          <Dropdown
            menu={{
              items,
            }}
            trigger={["click"]}
          >
            <Button
              type="text"
              className="tw-more-btn"
              icon={<EllipsisOutlined />}
            />
          </Dropdown>
        );
      },
    },
  ];

  const onSearch = debounce((event) => {
    onFilterChange("globalSearchTerm", event?.target?.value || undefined);
    onFilterChange("page", 1);
  }, 500);

  return (
    <>
      <div className="d-flex tw-mb-5 align-items-center gap-20 justify-content-between">
        <Button
          className="tw-btn-premium"
          onClick={() => {
            setAdd(true);
          }}
        >
          <PlusOutlined />
          Create New Team
        </Button>
        <Input
          defaultValue={searchParams.get("globalSearchTerm")}
          allowClear
          prefix={<SearchOutlined className="tw-text-slate-400" />}
          onChange={onSearch}
          className="tw-input-search-page"
          style={{ minWidth: 200, maxWidth: 300 }}
        />
      </div>
      <div className="tw-custom-table-container">
        <CommonTable
          columns={columns}
          dataSource={teams?.content}
          loading={loading}
          showSorterTooltip={true}
          className="tw-custom-table tw-table-max-content"
          sortDirections={["ascend", "descend"]}
          pagination={{
            pageSize: 10,
            total: teams?.totalElements,
            defaultCurrent: 1,
            current: page || 1,
            onChange: (page, pageSize) => {
              onFilterChange("page", page);
            },
          }}
          onChange={(pagination, filters, sorter) => {
            onFilterChange(
              "sort",
              !!sorter?.field
                ? sorter?.order === "ascend"
                  ? sorter?.field + ",asc"
                  : sorter?.field + ",desc"
                : undefined,
            );
          }}
        />
      </div>
      <EditTeam
        team={team}
        isOpen={team || isAdd}
        closeModal={() => {
          setTeam();
          setAdd(false);
        }}
      />
      <DeleteTeam
        isOpen={isDelete}
        isLoading={isLoading}
        handleCancel={() => setDelete()}
        handleDelete={handleDelete}
      />
    </>
  );
};

export default TeamListing;
